/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ClearingHouse, ClearingHouseInterface } from "../ClearingHouse";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegateApproval",
        type: "address",
      },
    ],
    name: "DelegateApprovalChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "fundingPayment",
        type: "int256",
      },
    ],
    name: "FundingPaymentSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "quoteToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int24",
        name: "lowerTick",
        type: "int24",
      },
      {
        indexed: false,
        internalType: "int24",
        name: "upperTick",
        type: "int24",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "base",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "quote",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int128",
        name: "liquidity",
        type: "int128",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteFee",
        type: "uint256",
      },
    ],
    name: "LiquidityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "exchangedPositionSize",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "exchangedPositionNotional",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "openNotional",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedPnl",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sqrtPriceAfterX96",
        type: "uint256",
      },
    ],
    name: "PositionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "closedPositionSize",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "closedPositionNotional",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "openNotional",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedPnl",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "closedPrice",
        type: "uint256",
      },
    ],
    name: "PositionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionNotional",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionSize",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidationFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "liquidator",
        type: "address",
      },
    ],
    name: "PositionLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "referralCode",
        type: "bytes32",
      },
    ],
    name: "ReferredPositionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "TrustedForwarderChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "trustedForwarder",
        type: "address",
      },
    ],
    name: "TrustedForwarderUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "base",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quote",
            type: "uint256",
          },
          {
            internalType: "int24",
            name: "lowerTick",
            type: "int24",
          },
          {
            internalType: "int24",
            name: "upperTick",
            type: "int24",
          },
          {
            internalType: "uint256",
            name: "minBase",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minQuote",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "useTakerBalance",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IClearingHouse.AddLiquidityParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "addLiquidity",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "base",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quote",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "liquidity",
            type: "uint256",
          },
        ],
        internalType: "struct IClearingHouse.AddLiquidityResponse",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "cancelAllExcessOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "orderIds",
        type: "bytes32[]",
      },
    ],
    name: "cancelExcessOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
          {
            internalType: "uint256",
            name: "oppositeAmountBound",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "referralCode",
            type: "bytes32",
          },
        ],
        internalType: "struct IClearingHouse.ClosePositionParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "closePosition",
    outputs: [
      {
        internalType: "uint256",
        name: "base",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAccountBalance",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getAccountValue",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouseConfig",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDelegateApproval",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getExchange",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getInsuranceFund",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOrderBook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getQuoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getUniswapV3Factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clearingHouseConfigArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "vaultArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "quoteTokenArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "uniV3FactoryArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "exchangeArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "accountBalanceArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "insuranceFundArg",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "int256",
        name: "positionSize",
        type: "int256",
      },
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isBaseToQuote",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isExactInput",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "oppositeAmountBound",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
          {
            internalType: "bytes32",
            name: "referralCode",
            type: "bytes32",
          },
        ],
        internalType: "struct IClearingHouse.OpenPositionParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "openPosition",
    outputs: [
      {
        internalType: "uint256",
        name: "base",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isBaseToQuote",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isExactInput",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "oppositeAmountBound",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
          {
            internalType: "bytes32",
            name: "referralCode",
            type: "bytes32",
          },
        ],
        internalType: "struct IClearingHouse.OpenPositionParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "openPositionFor",
    outputs: [
      {
        internalType: "uint256",
        name: "base",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "quitMarket",
    outputs: [
      {
        internalType: "uint256",
        name: "base",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "int24",
            name: "lowerTick",
            type: "int24",
          },
          {
            internalType: "int24",
            name: "upperTick",
            type: "int24",
          },
          {
            internalType: "uint128",
            name: "liquidity",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "minBase",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minQuote",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
        ],
        internalType: "struct IClearingHouse.RemoveLiquidityParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "removeLiquidity",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "base",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quote",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct IClearingHouse.RemoveLiquidityResponse",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegateApprovalArg",
        type: "address",
      },
    ],
    name: "setDelegateApproval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "settleAllFunding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Owed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1Owed",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "uniswapV3MintCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ClearingHouse__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ClearingHouse> {
    return super.deploy(overrides || {}) as Promise<ClearingHouse>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ClearingHouse {
    return super.attach(address) as ClearingHouse;
  }
  connect(signer: Signer): ClearingHouse__factory {
    return super.connect(signer) as ClearingHouse__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ClearingHouseInterface {
    return new utils.Interface(_abi) as ClearingHouseInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ClearingHouse {
    return new Contract(address, _abi, signerOrProvider) as ClearingHouse;
  }
}
